import axios from 'axios';
import { ahnHeader } from './authservice/ahn-header';
import { authHeader } from './authservice/auth-header';

// const API_URL = 'https://103.87.80.46:50006/api/v1/';
const API_URL = process.env.VUE_APP_BASE_API_URL;
const URL_N8N = 'http://10.10.30.233:5678/';

class MalwareService {
    uploadCheckpoint(data) {
        return axios.post(API_URL + 'malware/checkpoint/upload', data, { headers: authHeader() });
    }
    queryCheckpoint(data) {
        return axios.post(API_URL + 'malware/checkpoint/query', data, { headers: authHeader() });
    }
    qoutaCheckpoint(data) {
        return axios.post(API_URL + 'malware/checkpoint/qouta', data, { headers: authHeader() });
    }
    downloadCheckpoint(data) {
        return axios.post(API_URL + 'malware/checkpoint/download', data, { headers: authHeader() });
    }

    uploadAhn(data) {
        return axios.post(API_URL + 'malware/ahn/upload', data, { headers: authHeader() });
    }

    uploadCp(data) {
        return axios.post(API_URL + 'malware/cp/upload', data, { headers: authHeader() });
    }

    ahnRequestStatus(data) {
        return axios.post(API_URL + 'malware/ahn/status', data, { headers: authHeader() });
    }
    cpRequestStatus(data) {
        return axios.post(API_URL + 'malware/cp/status', data, { headers: authHeader() });
    }

    cpDetail(data) {
        return axios.post(API_URL + 'malware/cp/detail-info', data, { headers: authHeader() });
    }

    ahnAnalysisFile(type = 'gif', data) {
        if (type == 'gif') {
            return axios.post(API_URL + 'malware/ahn/download/gif', data, { headers: authHeader() });
        }
        if (type == 'mdp') {
            return axios.post(API_URL + 'malware/ahn/download/mdp', data, { headers: authHeader() });
        }
        if (type == 'dica') {
            return axios.post(API_URL + 'malware/ahn/download/dica', data, { headers: authHeader() });
        }
        if (type == 'pcap') {
            return axios.post(API_URL + 'malware/ahn/download/pcap', data, { headers: authHeader() });
        }
    }

    ahnSupiciousActivity(type, md5, vm) {
        if (type == '1') {
            return axios.get(API_URL + 'malware/ahn/suspicious-activities/1?md5=' + md5 + '&vm=' + vm, { headers: authHeader() });
        }
        if (type == '2') {
            return axios.get(API_URL + 'malware/ahn/suspicious-activities/2?md5=' + md5 + '&vm=' + vm, { headers: authHeader() });
        }
    }

    ahnDownloadFileXml(id) {
        return axios.get(API_URL + 'malware/ahn/mdp/' + id, { headers: authHeader() });
    }

    systemVM() {
        return axios.get(API_URL + 'malware/ahn/system/vm', { headers: authHeader() });
    }

    systemStatus() {
        return axios.get(API_URL + 'malware/ahn/system/status', { headers: authHeader() });
    }

    decodeReport(data) {
        return axios.post(URL_N8N + 'webhook/decode', data);
    }
}

export default new MalwareService();
